import { degrees2radians } from '../../functions';
import { Vertex2 } from '../vertex-2.class';

export const move2OnAxisCfn = (source: Vertex2, distance: number, angle: number): Vertex2 => {
	const radians = degrees2radians(angle);
	const dy = Math.sin(radians) * distance;
	const dx = Math.cos(-radians) * distance;

	// Add the displacement vector to the source point to get the moved point
	source.add(new Vertex2({ dataIn: {
		x: dx,
		y: dy
	}}));

	return source;
}
